import { defineMessages } from 'react-intl';

export default defineMessages({
  productNotExist: {
    id: 'globalUserMessage.productNotExist',
    defaultMessage: 'Could not find the product. Try product search.',
  },
});
